import FilterByPaymentType from './FilterByPaymentType';

export default FilterByPaymentType;
